export const noAccess = {
  title: 'Sem acesso',
  heading: 'Seu perfil não tem acesso a esta área',
  description: 'Se você precisa dela no trabalho, peça à diretoria para ajustar seu perfil.',
} as const
